export const updateAssignationStatus = (state, { payload: { id, status } }) =>
  state.setIn(['productMap', id, 'alkemics', 'assignation', 'status'], status);
